<template>
</template>

<script>

  export default {
    components: {
    },
    props: {
      delay: {
        type: Number,
        default: 5000,
      },
      itemType: {
        type: String,
        default: "none",
      },
      itemId: {
      },
      articleRecordId: {
      },
      page: {
      },
      action: {
        Type: String,
        default: 'none'
      }
    },
    name: "ItemActionStatsEmit",
    data() {
      return {
        timer: {},
      }
    },
    mounted() {
      this.timer = setTimeout(() => {
        this.emitItemViewStats()
      }, this.delay)
    },
    destroyed() {
      clearTimeout(this.timer)
    },

    methods: {
      emitItemViewStats() {
        try {
          let articleRecordId = this.articleRecordId?parseInt(this.articleRecordId):0
          let page = this.page ? parseInt(this.page): 0
          let params = {
            "item_id": parseInt(this.itemId),
            "item_type": '' + this.itemType,
            "action": '' + this.action,
            "article_record_id": articleRecordId,
            "page": page,
          }
          this.$store.dispatch("DoItemActionStats", params).then(()=> {
          }, ()=> {
          })
        } catch (e) {
          console.log(e)
        }
      },
    }
  }

</script>

<style lang="scss" scoped>

</style>
